var React = require('react');

function Scrap (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_1418_30246","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"26","height":"25","key":0},React.createElement("rect",{"x":"0.5","width":"25","height":"25","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_1418_30246)","key":1},React.createElement("path",{"d":"M7.7915 21.875C7.21859 21.875 6.72814 21.671 6.32015 21.263C5.91216 20.855 5.70817 20.3646 5.70817 19.7917V6.25H4.6665V4.16667H9.87484V3.125H16.1248V4.16667H21.3332V6.25H20.2915V19.7917C20.2915 20.3646 20.0875 20.855 19.6795 21.263C19.2715 21.671 18.7811 21.875 18.2082 21.875H7.7915ZM18.2082 6.25H7.7915V19.7917H18.2082V6.25ZM9.87484 17.7083H11.9582V8.33333H9.87484V17.7083ZM14.0415 17.7083H16.1248V8.33333H14.0415V17.7083Z","fill":"#1E93A5"}))]);
}

Scrap.defaultProps = {"width":"26","height":"25","viewBox":"0 0 26 25","fill":"none"};

module.exports = Scrap;

Scrap.default = Scrap;
